import React from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import { portfolio as t } from "../Themes"
import { Stats } from "../../data/ResumeData"
import { Section, Inner, Label, Heading, reveal, revealDelay } from "./ui"

const Grid = styled.div`
display: grid;
grid-template-columns: 1.4fr 1fr;
gap: clamp(2rem, 6vw, 5rem);
align-items: start;

@media (max-width: 56em){
    grid-template-columns: 1fr;
    gap: 2.5rem;
}
`

const Copy = styled(motion.div)`
color: ${t.muted};
font-size: 1.06rem;
line-height: 1.8;

p{ margin-bottom: 1.2rem; }
p:last-child{ margin-bottom: 0; }
b{ color: ${t.text}; font-weight: 600; }
a{ color: ${t.accent}; border-bottom: 1px solid rgba(${t.accentRgba}, 0.4); }
`

const Stack = styled.div`
display: grid;
gap: 1rem;
`

const Stat = styled(motion.div)`
border: 1px solid ${t.border};
border-radius: 16px;
padding: 1.4rem 1.5rem;
background: ${t.surface};
transition: border-color 0.25s ease, transform 0.25s ease;

&:hover{ border-color: ${t.borderHi}; transform: translateY(-3px); }

strong{
    display: block;
    font-family: ${t.display};
    font-size: clamp(1.8rem, 4vw, 2.4rem);
    color: ${t.text};
    line-height: 1;
}
span{
    font-family: ${t.mono};
    font-size: 0.82rem;
    color: ${t.muted};
}
`

const About = () => {
    return (
        <Section id="about" alt>
            <Inner>
                <Label num="01" {...reveal}>About</Label>
                <Heading {...reveal}>Engineering for reliability, scale and millions of users.</Heading>
                <Grid>
                    <Copy {...reveal}>
                        <p>
                            I'm a <b>Senior Software Engineer</b> with nearly 5 years across full-stack
                            development, telecom Value-Added Services and platform engineering,
                            based in Ethiopia.
                        </p>
                        <p>
                            I've designed, built and operated <b>enterprise-grade web apps, APIs and
                            digital channels</b> — USSD, SMS, M-PESA and FinTech flows — that serve
                            millions of customers. Today I'm a Senior Backend Developer at
                            InfraTech Software Solutions; previously I led Digital Channels and
                            engineered VAS platforms at <b>Safaricom Ethiopia</b>, where my work was
                            recognized by Safaricom Group leadership.
                        </p>
                        <p>
                            I care about clean systems, observability and high availability — and I
                            hold a B.Sc. in Computer Science from <b>Dire Dawa University</b>.
                        </p>
                    </Copy>
                    <Stack>
                        {Stats.map((s, i) => (
                            <Stat key={s.label} {...revealDelay(i)}>
                                <strong>{s.value}</strong>
                                <span>{s.label}</span>
                            </Stat>
                        ))}
                    </Stack>
                </Grid>
            </Inner>
        </Section>
    )
}

export default About
